import { Loader, TablePagination } from "@/src/components/ui/data-table";
import { Content } from "@/src/components/wrappers/Content";
import { SearchBar } from "./SearchBar";
import { useEffect, useState } from "react";
import { getApiFilters, SearchParamsContext, SearchResults, useSearch } from "./search";
import { YachtCard } from "./YachtCard";
import { useLoad } from "@/src/lib/useLoad";
import { SearchParams, searchParamsSchema } from "./search_params.model";
import { getSchemaDefaults } from "./form";
import { BMOnHoldButton } from "./OnHoldButton";

export function ApiYachts() {
  const [params, setSearchParams] = useState<SearchParams>({} as any);
  const [res, setRes] = useState<SearchResults>({
    data: [],
    total_results: 0,
    total_pages: 0,
    page: 1,
    page_size: 20,
  });
  const [loading, setLoading] = useState(false);

  const schema = useLoad(async () => {
    const filterParams = await getApiFilters();
    const paramsSchema = searchParamsSchema(filterParams);
    return paramsSchema;
  });

  useEffect(() => {
    if (schema) {
      console.log(getSchemaDefaults(schema));
    }
  }, [schema]);

  const { search } = useSearch();

  useEffect(() => {
    setLoading(true);
    search(params).then((r) => {
      setRes(r);
      setLoading(false);
    });
  }, [params]);

  // getIn({ key1: 2, key2: { nested1: null } }, "key2")

  return (
    <Content title="API Yachts">
      <SearchParamsContext.Provider value={params}>
        <div className="mb-2 flex flex-col gap-2">
          <div className="rounded-md overflow-hidden">
            <SearchBar params={params} setSearchParams={setSearchParams} />
            <div className="flex flex-col w-full rounded-md gap-8 overflow-hidden ">
              {loading && <Loader />}
              {!loading &&
                res.data.map((yd) => <YachtCard key={yd.id} data={yd} actions={<BMOnHoldButton yachtId={yd.id} />} />)}
              <TablePagination
                onPageClick={(page) =>
                  setSearchParams({
                    ...params,
                  })
                }
                pagination={{
                  total: res.total_results,
                  pagination: {
                    page: res.page,
                    pageSize: res.page_size,
                  },
                }}
              />
            </div>
          </div>
        </div>
      </SearchParamsContext.Provider>
    </Content>
  );
}
